<template>
<div class="fc-page mg-page mg-stop_date_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>停课管理</h1><p>统一设置校区停课日期与停课原因</p></div><div class="mg-heading-actions"><v-btn @click="shopStop.show=true"  color="#d9363e" dense depressed class="mg-create">停课设置</v-btn></div></header><section class="fc-records" aria-label="停课记录"><div class="fc-list-heading"><h3>停课记录</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">



		</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><setShopStopDate :show="shopStop.show" @cancel="shopStop.show=false" @success="setShopStopSuccess"></setShopStopDate></div>
</template>

<script>

	import utils from "../../../config/utils.js"
	import setShopStopDate from "../../../components/set_shop_stop_date.vue"
	export default {
		name: "shop-stop-list",
		components:{setShopStopDate},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [
					{text: '首页',disabled: false,href: "/"},
					{text: '系统管理',disabled: true},
					{text: '停课管理',disabled: true},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{text: '开始日期',value: 'dateFrom',sortable: false},
						{text: '结束日期',value: 'dateTo',sortable: false},
						{text: '停课原因',value: 'stopReason',sortable: false},
						{text: '顺延课次数',value: 'dealRecordCount',sortable: false},
						{text: '创建时间',value: 'createAt',sortable: false},
						{text: '创建人',value: 'creatorName',sortable: false},
					],
					list: [],
				},
				query: {
					loading:false,
					page: 1,
					size: 20,
				},
				shopStop:{
					show:false
				}
				
				
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.getDataTableList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getDataTableList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getDataTableList();
			},
			setShopStopSuccess(){
				this.shopStop.show= false;
				this.getDataTableList();
			},
			getDataTableList() {
				const that = this;
				this.query.loading = true;
				let url = `/sys/shop/${this.shopId}/stop/date/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						
						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			

		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
